export default __webpack_public_path__ + "static/media/header-main-merge-two.b51b57d0.svg";